(()=>{"use strict";const selector="iframe.smile-panel-frame",styleId="cabane-smile-beige",trackedFrames=new WeakSet,pendingDocuments=new WeakSet,headingFont=document.querySelector('link[rel="preload"][as="font"][href*="preview-anton-400.ttf"]')?.href,css=`
    ${headingFont?`@font-face { font-family: 'Cabane Anton'; src: url(${JSON.stringify(headingFont)}) format('truetype'); font-weight: 400; font-style: normal; font-display: swap; }`:""}
    body.panel-body { color: #111111 !important; }
    .panel-body .panel-wrapper {
      --banner-base-colour: #f3e7d7 !important;
      --banner-gradient-dark-colour: #f3e7d7 !important;
      --link-colour: #b94318 !important;
    }
    .panel-body .main-panel-container,
    .panel-body .panel-expanded-header,
    .panel-body .panel-fixed-header,
    .panel-body .panel-footer {
      background-color: #f3e7d7 !important;
      background-image: none !important;
      color: #111111 !important;
    }
    .panel-body .panel-card-container,
    .panel-body .panel-subview {
      background-color: #f8efe3 !important;
      color: #111111 !important;
      box-shadow: 0 0 0 1px #ddcbb4 !important;
    }
    .panel-body .banner-content { color: #111111 !important; text-shadow: none !important; }
    .panel-body .points-balance,
    .panel-body .card-list-title,
    .panel-body .card-heading,
    .panel-body .list-title .heading {
      color: #b94318 !important;
    }
    .panel-body .text-muted { color: #62594f !important; }
    .panel-body .card-list-title.text-muted { color: #b94318 !important; }
    .panel-body .card-list-item { color: #111111 !important; }
    .panel-body .card-list-item:hover { background-color: #ebdcc8 !important; }
    .panel-body .card-list-item:active { background-color: #dfc9ad !important; }
    .panel-body .card-list-container.with-border-bottom { border-color: #ddcbb4 !important; }
    .panel-body .panel-footer { border-top: 1px solid #ddcbb4; box-shadow: none !important; }
    .panel-body .powered-by-text { color: #62594f !important; }
    .panel-body .compact-banner.panel-header-container .panel-expanded-header {
      height: 200px;
      padding: 64px 24px 20px;
    }
    .panel-body .compact-banner.panel-header-container.expanded-header + .panel-container {
      padding-top: 188px;
    }
    .panel-body .compact-banner.panel-header-container.collapsed .panel-expanded-header {
      transform: translate3d(0, -140px, 0) !important;
    }
    .panel-body .banner-content .header-icon:empty { display: none; }
    .panel-body .banner-content .header-secondary {
      font: 600 10px/1.2 Arial, sans-serif;
      letter-spacing: 1.6px;
      margin-bottom: 10px;
      color: #111111;
    }
    .panel-body .banner-content .header-primary {
      color: #111111 !important;
      font-family: 'Cabane Anton', Impact, 'Arial Narrow', sans-serif !important;
      font-size: 34px !important;
      font-weight: 400;
      line-height: 1.04;
      letter-spacing: 0.15px;
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
    }
    .panel-body .cabane-smile-title-line { display: block; }
    .panel-body .banner-content .header-primary::after {
      content: '';
      display: block;
      width: 42px;
      height: 4px;
      margin-top: 12px;
      background: #ef6a32;
    }
  `;function styleTitle(doc){const title=doc.querySelector(".banner-content .header-primary");if(!title||title.querySelector(".cabane-smile-title-line")||title.textContent.trim()!=="TON SHOP. TES AVANTAGES.")return;const first=doc.createElement("span"),second=doc.createElement("span");first.className=second.className="cabane-smile-title-line",first.textContent="TON SHOP. ",second.textContent="TES AVANTAGES.",title.replaceChildren(first,second)}function apply(frame){let doc;try{doc=frame.contentDocument}catch{return}if(!doc||doc.getElementById(styleId))return;if(doc.head){const style=doc.createElement("style");style.id=styleId,style.textContent=css,doc.head.appendChild(style),styleTitle(doc),new MutationObserver(()=>styleTitle(doc)).observe(doc,{childList:!0,subtree:!0});return}if(pendingDocuments.has(doc))return;pendingDocuments.add(doc);const ready=new MutationObserver(()=>{doc.head&&(ready.disconnect(),apply(frame))});ready.observe(doc,{childList:!0,subtree:!0})}function track(frame){trackedFrames.has(frame)||(trackedFrames.add(frame),frame.addEventListener("load",()=>apply(frame)),apply(frame))}function scan(node){node.nodeType===Node.ELEMENT_NODE&&(node.matches(selector)&&track(node),node.querySelectorAll(selector).forEach(track))}document.querySelectorAll(selector).forEach(track),new MutationObserver(records=>{for(const record of records)record.addedNodes.forEach(scan)}).observe(document.body,{childList:!0,subtree:!0})})(),(()=>{"use strict";const mobile=window.matchMedia("(max-width: 749px)"),frameSelector="#smile-lite-launcher-frame, iframe.smile-launcher-frame",tracked=new WeakSet,launcherStyles=new Set,styleId="cabane-mobile-widgets",pageStyle=document.createElement("style");pageStyle.textContent=`
    @media (max-width: 749px) {
      :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container) {
        width: 100px !important;
        height: 44px !important;
        left: max(12px, env(safe-area-inset-left)) !important;
        bottom: calc(12px + env(safe-area-inset-bottom)) !important;
      }
      shopify-chat::part(activator) {
        width: 44px !important;
        min-width: 44px !important;
        height: 44px !important;
      }
      html.cabane-widget-text-overlap shopify-chat::part(activator),
      html.cabane-widget-text-overlap :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container) {
        visibility: hidden !important;
        pointer-events: none !important;
      }
      html.lcg-chat-sensitive :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      html.lcg-search-open :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      html:has(.lcg-shop-menu[open]) :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      body.lcg-wishlist-locked :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      body.lcg-consent-open :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      body:has(cart-drawer.active) :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container),
      body:has(.mobile-facets__disclosure[open]) :is(#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container) {
        visibility: hidden !important;
        pointer-events: none !important;
      }
    }
  `,document.head.appendChild(pageStyle);let visibilityFrame;
const textSelector = 'main h1, main h2, main h3, main h4, main p, main button, main label, footer h2, footer p, footer input';
let trackedText = new WeakSet();
let textZones = [];

function updateTextVisibility() {
  let overlap = false;
  for (const zone of textZones) {
    for (const element of zone.overlaps) {
      if (!element.isConnected) {
        zone.overlaps.delete(element);
        zone.observer.unobserve(element);
      } else {
        overlap = true;
      }
    }
  }
  const root = document.documentElement;
  const next = mobile.matches && overlap;
  if (root.classList.contains('cabane-widget-text-overlap') !== next) {
    root.classList.toggle('cabane-widget-text-overlap', next);
  }
}

function observeText(node) {
  if (!mobile.matches || !textZones.length || node.nodeType !== 1) return;
  const elements = node.matches(textSelector) ? [node] : [];
  elements.push(...node.querySelectorAll(textSelector));
  for (const element of elements) {
    if (trackedText.has(element)) continue;
    trackedText.add(element);
    for (const zone of textZones) zone.observer.observe(element);
  }
}

function refreshTextZones() {
  visibilityFrame = undefined;
  for (const zone of textZones) zone.observer.disconnect();
  textZones = [];
  trackedText = new WeakSet();
  if (mobile.matches) {
    const height = window.innerHeight;
    const width = document.documentElement.clientWidth;
    const launcher = document.querySelector('#smile-ui-lite-launcher-frame-container, #smile-ui-container .smile-launcher-frame-container');
    const bottom = Math.min(height, launcher?.getBoundingClientRect().bottom || height - 12);
    // The browser tracks these two 44px-high areas; no layout reads on scroll.
    const topInset = Math.max(0, bottom - 44);
    const bottomInset = Math.max(0, height - bottom);
    for (const [left, right] of [[12, 112], [width - 56, width - 12]]) {
      const zone = { overlaps: new Set(), observer: null };
      zone.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          const intersects = entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
          if (intersects) zone.overlaps.add(entry.target);
          else zone.overlaps.delete(entry.target);
        }
        updateTextVisibility();
      }, {
        rootMargin: `-${topInset}px -${Math.max(0, width - right)}px -${bottomInset}px -${Math.max(0, left)}px`,
        threshold: [0, 0.00001]
      });
      textZones.push(zone);
    }
    observeText(document.body);
  }
  updateTextVisibility();
}

function scheduleTextVisibility() {
  if (visibilityFrame === undefined) visibilityFrame = requestAnimationFrame(refreshTextZones);
}
window.addEventListener('resize', scheduleTextVisibility, { passive: true });
mobile.addEventListener('change', scheduleTextVisibility);
scheduleTextVisibility();
function styleLauncher(frame){let doc;try{doc=frame.contentDocument}catch{return}if(!doc?.head||doc.getElementById(styleId))return;const style=doc.createElement("style");style.id=styleId,style.media=mobile.matches?"all":"not all",style.textContent=`
      button, button.smile-improved-mobile-launcher {
        box-sizing: border-box !important;
        width: 100px !important;
        min-width: 100px !important;
        height: 44px !important;
        max-height: 44px !important;
        padding: 0 10px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 6px !important;
        font-size: 12px !important;
        line-height: 1 !important;
      }
      button img, button.smile-improved-mobile-launcher img {
        width: 20px !important;
        height: 20px !important;
        flex: 0 0 20px !important;
      }
      button img + span { margin-left: 0 !important; }
      button.launcher-button { padding: 0 !important; }
      .launcher-container {
        box-sizing: border-box !important;
        width: 100px !important;
        height: 44px !important;
        min-height: 44px !important;
        padding: 0 10px !important;
        justify-content: center !important;
      }
      .launcher-content-container {
        align-items: center !important;
        justify-content: center !important;
        gap: 6px !important;
      }
      .launcher-text { margin: 0 !important; font-size: 12px !important; line-height: 20px !important; }
      .launcher-close-icon { width: 20px !important; height: 20px !important; margin: 12px 40px !important; }
      .close-icon { width: 20px; height: 20px; margin: 12px auto; }
    `,doc.head.appendChild(style),launcherStyles.add(style)}const chatAssetBase = document.currentScript?.src || document.querySelector('script[src*="cabane-smile-brand.js"]')?.src;
const chatPaper = chatAssetBase ? new URL('cabane-paper-texture.webp', chatAssetBase).href : '';
const chatInk = chatAssetBase ? new URL('nr-cta-texture.png', chatAssetBase).href : '';
function styleChatIcons(root){
  root.querySelectorAll('shopify-chat-icon-button, shopify-chat-icon-button-group').forEach(host=>{
    const inner=host.shadowRoot;
    if(!inner || inner.getElementById('cabane-chat-icons'))return;
    const style=document.createElement('style');style.id='cabane-chat-icons';
    style.textContent='button,.interior,ul{border-radius:0!important;box-shadow:none!important}button{min-width:40px;min-height:40px}button:focus-visible{outline:2px solid #111!important;outline-offset:-3px!important}';
    inner.appendChild(style);
  });
}
function styleChat(host,attempts=0){const root=host.shadowRoot;if(!root){host.isConnected&&attempts<20&&window.setTimeout(()=>styleChat(host,attempts+1),250);return}if(root.getElementById(styleId))return;const style=document.createElement("style");style.id=styleId,style.textContent=`
      :host {
        --shopify-chat-bg-color:#f3e7d7!important;
        --shopify-chat-text-color:#111!important;
        --shopify-chat-accent-bg-color:#111!important;
        --shopify-chat-accent-text-color:#f3e7d7!important;
        --shopify-chat-border-radius:0px!important;
        --shopify-chat-font-size:14px!important;
        --shopify-chat-body-font-family:'Roboto Mono',monospace!important;
        --shopify-chat-heading-font-family:Anton,Impact,sans-serif!important;
        font-family:'Roboto Mono',monospace!important;
      }
      button.activator {
        border:1px solid #111!important;border-radius:0!important;
        background:#111 url(${JSON.stringify(chatInk)}) center/cover!important;
        color:#f3e7d7!important;box-shadow:none!important;
        font:500 12px/1.3 'Roboto Mono',monospace!important;text-transform:uppercase;
        min-height:44px!important;
      }
      .activator__label{font:inherit!important;letter-spacing:.04em}
      .activator__label,.activator__icon,.activator__icon shopify-chat-icon{color:#f3e7d7!important}
      .activator__indicator{background:#ef6a32!important}
      .panel{border:1px solid #111!important;border-radius:0!important;box-shadow:0 6px 24px #1112!important;background:#f3e7d7 url(${JSON.stringify(chatPaper)}) repeat!important}
      .panel__header{background:#f3e7d7 url(${JSON.stringify(chatPaper)}) repeat!important;border-bottom:1px solid #b9a58c!important}
      .panel,.panel__header{background-blend-mode:multiply!important;background-size:1440px auto!important}
      .panel__customer-identity,.panel__customer-avatar,.panel__customer-initial,.panel__customer-menu,.panel__customer-menu-item,.new-chat-popover,.new-chat-popover__button,.panel__unavailable-retry{border-radius:0!important;box-shadow:none!important}
      .panel__customer-identity{border:1px solid #111!important;min-height:40px!important;font:500 12px/1.3 'Roboto Mono',monospace!important}
      .panel__customer-menu,.new-chat-popover{border:1px solid #111!important}
      .panel__customer-menu-item{font-family:'Roboto Mono',monospace!important}
      .new-chat-popover__title,.panel__unavailable-title{font:400 24px/1.2 Anton,Impact,sans-serif!important;text-transform:uppercase}
      button:focus-visible{outline:2px solid #111!important;outline-offset:-3px!important}
      @media (max-width: 749px) {
        .activator-nudge--right {
          right: max(12px, env(safe-area-inset-right)) !important;
          bottom: calc(12px + env(safe-area-inset-bottom)) !important;
        }
        button.activator {
          width: 44px !important;
          min-width: 44px !important;
          height: 44px !important;
          padding: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 0 !important;
        }
        .activator__label { display: none !important; }
        .activator__icon {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 22px !important;
          height: 22px !important;
          margin: 0 !important;
          flex: 0 0 22px !important;
        }
        .activator__icon svg { display: block; width: 22px; height: 22px; }
        .activator__icon shopify-chat-icon { display: flex; align-items: center; justify-content: center; width: 22px; height: 22px; }
      }
    `,root.appendChild(style);host.refreshTheme?.();const trackRuntime=()=>{styleChatIcons(root);root.querySelectorAll("shopify-agent-runtime").forEach(runtime=>{tracked.has(runtime)||(tracked.add(runtime),customElements.whenDefined("shopify-agent-runtime").then(()=>styleChat(runtime)))})};trackRuntime(),new MutationObserver(trackRuntime).observe(root,{childList:!0,subtree:!0})}function track(node){tracked.has(node)||(tracked.add(node),node.matches(frameSelector)?(node.addEventListener("load",()=>styleLauncher(node)),styleLauncher(node)):customElements.whenDefined("shopify-chat").then(()=>styleChat(node)))}const selector=`${frameSelector}, shopify-chat`;function scan(node){observeText(node);node.nodeType===Node.ELEMENT_NODE&&(node.matches(selector)&&track(node),node.querySelectorAll(selector).forEach(track))}document.querySelectorAll(selector).forEach(track),new MutationObserver(records=>{for(const record of records)record.addedNodes.forEach(scan)}).observe(document.body,{childList:!0,subtree:!0}),mobile.addEventListener("change",()=>{for(const style of launcherStyles)style.isConnected?style.media=mobile.matches?"all":"not all":launcherStyles.delete(style)})})();
//# sourceMappingURL=/cdn/shop/t/42/assets/cabane-smile-brand.js.map?v=183758975449863934311791465137

